import { render, staticRenderFns } from "./mainNav.vue?vue&type=template&id=36041ebe&scoped=true"
import script from "./mainNav.vue?vue&type=script&lang=js"
export * from "./mainNav.vue?vue&type=script&lang=js"
import style0 from "./mainNav.vue?vue&type=style&index=0&id=36041ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36041ebe",
  null
  
)

export default component.exports